$.onmount('[data-component=shipment-receipts-toggle]', function() {
  $(this).on('click', function() {
    var modalTarget = $(this).data('target');
    var modalElement = $('[data-modal=' + modalTarget + ']');
    modalElement.modal('show');
  });
});
